import { Currency } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

export const getCurrencyFromString = (currencyString: string): Currency => {
  switch (currencyString) {
    case "USD":
      return Currency.USD;
    case "AUD":
      return Currency.AUD;
    case "EUR":
      return Currency.EUR;
    case "GBP":
      return Currency.GBP;
    default:
      return Currency.USD;
  }
};
